<template>
    <div class="marketing-award-button">
        <div
            class="button"
            :class="{ 'is-disabled': disabled }"
            :style="btnStyle"
            @click="handleClick"
        >
            {{ text }}
        </div>
    </div>
</template>

<script>
  import { buttonConfigMap } from './helper';

  export default {
      props: {
          isLoading: Boolean,
          status: String,
          notReceivedBtnImg: String,
          notAvailableBtnImg: String,
          receivedBtnImg: String
      },
      data() {
          return {};
      },
      computed: {
          btnImage() {
              const { btnImageName } = buttonConfigMap[this.status];
              return this[btnImageName] || '';
          },
          text() {
              const { btnText = '' } = buttonConfigMap[this.status];
              return this.btnImage ? '' : btnText;
          },
          btnStyle() {
              const bg = this.getImgBgStyle(this.btnImage);
              const border = this.getBtnBorderStyle(this.btnImage);

              return [bg, border];
          },
          disabled() {
              const { isClickable } = buttonConfigMap[this.status];

              return !isClickable || this.isLoading;
          }
      },
      methods: {
          async handleClick() {
              this.$emit('action');
          },
          getImgBgStyle(url) {
              if (url) {
                  return {
                      background: `center / cover no-repeat url(${url})`
                  };
              }
              return {};
          },
          getBtnBorderStyle(url) {
              if (url) {
                  return { borderWidth: '0' };
              }
              return { borderWidth: `${100 / 375}vw` };
          }
      }
  };
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-award-button {
    margin: 20 * @layout375 20 * @layout375 34 * @layout375;
    .button {
        cursor: pointer;
        .center();
        height: 45 * @layout375;
        font-size: 16 * @layout375;
        color: #ffffff;
        background: @text_basic_active;
        border-radius: 25 * @layout375;
        border: 1 * @layout375 solid transparent;
        position: relative;
        &.is-disabled,
        &.is-disabled:active {
            color: #ffffff;
            background-color: @background_disable;
            filter: brightness(100%);
            cursor: not-allowed;
        }
        &:active {
            filter: brightness(80%);
            // background: #009292;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/award/award-button.vue